/**
 * Small display-formatting helpers shared across features.
 */

/** "Ada Lovelace" -> "AL". '?' when nothing usable remains. */
export function getInitials(name: string | null | undefined): string {
  const raw = (name ?? '').trim();
  if (!raw) return '?';
  const parts = raw.split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? '').join('') || '?';
}

/**
 * "Acme's Workspace" default name. Precedence: company domain's root,
 * first name token, email prefix, then a bare fallback.
 */
export function suggestedWorkspaceName({
  domain,
  fullName,
  email,
}: {
  domain?: string;
  fullName?: string | null;
  email?: string;
}): string {
  const pretty = (domain || '').split('.')[0] || '';
  if (pretty) return `${pretty.charAt(0).toUpperCase() + pretty.slice(1)}'s Workspace`;
  const first = (fullName ?? '').trim().split(/\s+/)[0];
  if (first) return `${first}'s Workspace`;
  const prefix = (email || '').split('@')[0];
  if (prefix) return `${prefix}'s Workspace`;
  return 'My Workspace';
}
